<script setup>
import FacebookIcon from '@/icons/FacebookIcon.vue'
import LinkedInIcon from '@/icons/LinkedInIcon.vue'

const year = new Date().getFullYear()
</script>


<template>
	<footer class=" mt-auto w-[100%]  bg-gray-50 p-4 text-gray-500 ">
		<div class=" flex text-center md:text-left flex-col md:grid md:grid-cols-3 text-xs ">
			<div class="flex flex-col md:items-center  ">
				<div >
					<p>Advance Cairns</p>
					<p>Level 1, Ports North Building</p>
					<p>Cnr Grafton &amp; Hartley Streets</p>
					<p>Cairns, QLD, 4870, AUSTRALIA</p>
					<p class="mt-2 text-">© Copyright {{ year }} Advance Cairns Limited</p>
									
				</div>
			</div>
			<div class="flex flex-col md:items-center ">
				<div>
					<p>PO Box 3065</p>
					<p>Cairns, QLD, 4870</p>
					<p>Australia</p>
				</div>
			</div>
			<div class="flex flex-col md:items-center ">
				<div>
					<p>(+61 7) 4080 2900</p>
					<p>admin@advancecairns.com</p>
					<p>ACN: 27 153 902 759</p>
					<div class="flex mt-2 justify-center md:justify-start">
						<a href="https://www.facebook.com/AdvanceCairns/">
							<FacebookIcon class="w-5 h-5 fill-gray-400" />
						</a>
						<a href="https://www.linkedin.com/company/advance-cairns/">
							<LinkedInIcon class=" ml-2 w-5 h-5 fill-gray-400" />
						</a>
					</div>
				</div>
			</div>
		</div>
			
	
	</footer>

</template>

